import React from 'react';
import {
	replaceId,
	demoteId,
	promoteId,
	pinId
} from '../Ranking/utils';
import TabBar from '../../../Components/TabBar';
import TabItem from '../../../Components/TabItem';

export const TabManualSorting = ({
	activeTab,
	setActiveTab,
	showPinManualSortingTab,
	canUseShopifyManualSorting
}) => {

	return (
		<TabBar hasBorder={false}>
			{showPinManualSortingTab &&
				<TabItem
					message='Pin'
					selected={activeTab === pinId}
					onClick={() => setActiveTab(pinId)}
				/>
			}
			{!canUseShopifyManualSorting &&
				<TabItem
					message='Promote'
					selected={activeTab === promoteId}
					onClick={() => setActiveTab(promoteId)}
				/>
			}
			<TabItem
				message='Demote'
				selected={activeTab === demoteId}
				onClick={() => setActiveTab(demoteId)}
			/>
			<TabItem
				message='Swap'
				selected={activeTab === replaceId}
				onClick={() => setActiveTab(replaceId)}
			/>
		</TabBar>
	);
};
